// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__VewyB","rotate":"Loader_rotate__wCV1g"};